import { DateTime } from "luxon";

interface GetReminderDaysIntervalProps {
  startDate?: string;
  endDate: string;
}

export const getReminderDaysInterval = ({
  startDate,
  endDate,
}: GetReminderDaysIntervalProps): number => {
  const today = DateTime.now().startOf("day");
  const convertedStartDate = startDate
    ? DateTime.fromISO(startDate).startOf("day")
    : today;
  const convertedEndDate = DateTime.fromISO(endDate).startOf("day");
  const daysInterval = convertedStartDate.diff(convertedEndDate, "days").days;

  return daysInterval;
};
